import React, { useState, useMemo } from 'react';
/*import { 
  Calendar, 
  MapPin, 
  ExternalLink, 
  Search, 
  Filter,
  Info,
  X
} from 'lucide-react';
*/
import { 
  ChevronRight, 
  Calendar, 
  MapPin,
  ExternalLink,
  Search, 
  Filter,
  Globe,
  Users,
  Presentation,
  CalendarDays
} from 'lucide-react';
// Sample conference data
const conferences = [
  {
    title: "Quantum Energy Initiative Workshop",
    startDate: "2025-01-06",
    endDate: "2025-01-10",
    location: "Grenoble",
    country: "France",
    month: "January",
    description: "A comprehensive workshop focusing on quantum energy initiatives and developments."
  },
  {
    title: "SPIE Quantum West",
    startDate: "2025-01-25",
    endDate: "2025-01-30",
    location: "San Francisco",
    country: "United States",
    month: "January",
    description: "Major conference on quantum technologies and applications."
  },
  {
    title: "QIP 2025",
    startDate: "2025-02-24",
    endDate: "2025-02-28",
    location: "Raleigh",
    country: "United States",
    month: "February",
    description: "28th Annual Quantum Information Processing Conference"
  },
  {
    title: "Quantum Australia Conference 2025",
    startDate: "2025-03-25",
    endDate: "2025-03-27",
    location: "Brisbane",
    country: "Australia",
    month: "March",
    description: "Leading quantum computing conference in the Asia-Pacific region"
  },
  {
    title: "Quantum Networks Summit 2025",
    startDate: "2025-03-25",
    endDate: "2025-03-26",
    location: "Paris",
    country: "France",
    month: "March",
    description: "Summit focused on quantum networking advances and challenges"
  },
  {
    title: "Quantum Computing Expo",
    startDate: "2025-04-15",
    endDate: "2025-04-17",
    location: "Tokyo",
    country: "Japan",
    month: "April",
    description: "Major expo showcasing the latest in quantum computing technology"
  }
];

const months = [
  "January", "February", "March", "April", "May", "June",
  "July", "August", "September", "October", "November", "December"
];

const countries = [...new Set(conferences.map(conf => conf.country))].sort();

const EventsPage = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedMonth, setSelectedMonth] = useState('all');
  const [selectedCountry, setSelectedCountry] = useState('all');

  const filteredConferences = useMemo(() => {
    return conferences.filter(conference => {
      const matchesSearch = conference.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
                          conference.location.toLowerCase().includes(searchTerm.toLowerCase());
      const matchesMonth = selectedMonth === 'all' || conference.month === selectedMonth;
      const matchesCountry = selectedCountry === 'all' || conference.country === selectedCountry;
      
      return matchesSearch && matchesMonth && matchesCountry;
    });
  }, [searchTerm, selectedMonth, selectedCountry]);

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Hero Section */}
      return (
    <div className="relative overflow-hidden bg-gradient-to-r from-blue-900 to-indigo-900">
      <div className="relative pt-16 pb-20 sm:pt-24 sm:pb-28">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            {/*<h1 className="text-4xl font-bold tracking-tight text-white sm:text-5xl md:text-6xl">*/}
            <h1 className="text-4xl font-bold mb-6 text-white">
              <span className="block">Global Quantum</span>
              <span className="block text-blue-400">Events & Conferences</span>
            </h1>
            <p className="mx-auto mt-6 max-w-2xl text-lg text-gray-300">
              Discover quantum computing conferences, workshops, and events worldwide. Connect with leading researchers, professionals, and organizations shaping the quantum future.
            </p>
            {/*}
            <div className="mt-10 flex flex-col sm:flex-row justify-center gap-4">
              <button className="rounded-md bg-blue-500 px-6 py-3 text-white hover:bg-blue-600 flex items-center justify-center">
                Browse Events
                <ChevronRight className="ml-2 h-4 w-4" />
              </button>
              <button className="rounded-md border border-white px-6 py-3 text-white hover:bg-white/10 flex items-center justify-center">
                Submit Event
                <Calendar className="ml-2 h-4 w-4" />
              </button>
            </div>
            */}

            {/* Event Stats */}
            {/*}
            <div className="mt-12 bg-white/10 rounded-lg p-6 max-w-3xl mx-auto backdrop-blur-sm">
              <h2 className="text-2xl font-semibold text-white mb-3">2025 Event Highlights</h2>
              <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                <div className="bg-white/5 p-4 rounded-lg">
                  <div className="font-bold text-blue-400 text-3xl mb-1">160+</div>
                  <div className="text-gray-300">Global Events</div>
                </div>
                <div className="bg-white/5 p-4 rounded-lg">
                  <div className="font-bold text-blue-400 text-3xl mb-1">40+</div>
                  <div className="text-gray-300">Countries</div>
                </div>
                <div className="bg-white/5 p-4 rounded-lg">
                  <div className="font-bold text-blue-400 text-3xl mb-1">12</div>
                  <div className="text-gray-300">Months</div>
                </div>
                <div className="bg-white/5 p-4 rounded-lg">
                  <div className="font-bold text-blue-400 text-3xl mb-1">1000s</div>
                  <div className="text-gray-300">Attendees</div>
                </div>
              </div>
            </div>
            */}

            {/* Event Categories */}
            {/*}
            <div className="mt-16 grid grid-cols-1 gap-8 sm:grid-cols-3">
              <div className="flex flex-col items-center">
                <Presentation className="h-12 w-12 text-blue-400" />
                <h3 className="mt-4 text-xl font-semibold text-white">Conferences</h3>
                <p className="mt-2 text-gray-300">Major quantum computing gatherings</p>
              </div>
              <div className="flex flex-col items-center">
                <Users className="h-12 w-12 text-blue-400" />
                <h3 className="mt-4 text-xl font-semibold text-white">Workshops</h3>
                <p className="mt-2 text-gray-300">Hands-on learning experiences</p>
              </div>
              <div className="flex flex-col items-center">
                <Globe className="h-12 w-12 text-blue-400" />
                <h3 className="mt-4 text-xl font-semibold text-white">Summits</h3>
                <p className="mt-2 text-gray-300">Industry-leading conventions</p>
              </div>
            </div>
            */}

            {/* Quick Filters */}
            {/*}
            <div className="mt-12 grid grid-cols-2 md:grid-cols-4 gap-4 max-w-3xl mx-auto">
              <button className="text-gray-300 hover:text-white flex items-center justify-center gap-2 bg-white/5 rounded-lg p-3 transition-colors">
                <CalendarDays className="h-4 w-4" />
                <span>This Month</span>
              </button>
              <button className="text-gray-300 hover:text-white flex items-center justify-center gap-2 bg-white/5 rounded-lg p-3 transition-colors">
                <MapPin className="h-4 w-4" />
                <span>Near You</span>
              </button>
              <button className="text-gray-300 hover:text-white flex items-center justify-center gap-2 bg-white/5 rounded-lg p-3 transition-colors">
                <Presentation className="h-4 w-4" />
                <span>Conferences</span>
              </button>
              <button className="text-gray-300 hover:text-white flex items-center justify-center gap-2 bg-white/5 rounded-lg p-3 transition-colors">
                <Filter className="h-4 w-4" />
                <span>All Filters</span>
              </button>
            </div>
            */}
          </div>
        </div>
      </div>
    </div>
  );

      {/* Filters Section */}
      <div className="sticky top-16 bg-white border-b z-10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <div className="flex flex-col md:flex-row gap-4 items-center justify-between">
            <div className="relative flex-1">
              <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 h-5 w-5" />
              <input
                type="text"
                placeholder="Search events..."
                className="pl-10 pr-4 py-2 border rounded-md w-full focus:outline-none focus:ring-2 focus:ring-blue-500"
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>
            <div className="flex gap-4">
              <select
                className="border rounded-md px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                onChange={(e) => setSelectedMonth(e.target.value)}
                value={selectedMonth}
              >
                <option value="all">All Months</option>
                {months.map(month => (
                  <option key={month} value={month}>{month}</option>
                ))}
              </select>
              <select
                className="border rounded-md px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                onChange={(e) => setSelectedCountry(e.target.value)}
                value={selectedCountry}
              >
                <option value="all">All Countries</option>
                {countries.map(country => (
                  <option key={country} value={country}>{country}</option>
                ))}
              </select>
            </div>
          </div>
        </div>
      </div>

      {/* Events List */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        {months.map(month => {
          const monthEvents = filteredConferences.filter(conf => conf.month === month);
          if (monthEvents.length === 0) return null;

          return (
            <div key={month} className="mb-12">
              <h2 className="text-2xl font-bold text-gray-900 mb-6">{month}</h2>
              <div className="grid gap-4">
                {monthEvents.map((conference, index) => (
                  <div 
                    key={index}
                    className="bg-white rounded-lg shadow-sm p-6 hover:shadow-md transition-shadow"
                  >
                    <div className="flex items-start justify-between">
                      <div className="flex-1">
                        <h3 className="text-lg font-semibold text-blue-600">{conference.title}</h3>
                        <p className="text-gray-600 mt-1">{conference.description}</p>
                        <div className="mt-2 space-y-2">
                          <div className="flex items-center text-gray-600">
                            <Calendar className="h-4 w-4 mr-2" />
                            <span>{conference.startDate} - {conference.endDate}</span>
                          </div>
                          <div className="flex items-center text-gray-600">
                            <MapPin className="h-4 w-4 mr-2" />
                            <span>{conference.location}, {conference.country}</span>
                          </div>
                        </div>
                      </div>
                      <button 
                        className="text-blue-600 hover:text-blue-800 ml-4"
                        title="Visit Event Website"
                      >
                        <ExternalLink className="h-5 w-5" />
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default EventsPage;